export default "__VITE_ASSET__05dde08e__"